
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface MobileMenuProps {
  isOpen: boolean;
  isAdmin: boolean;
  onClose: () => void;
  onSignUpClick: () => void;
  onAdminDashboardClick: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({
  isOpen,
  isAdmin,
  onClose,
  onSignUpClick,
  onAdminDashboardClick
}) => {
  // We're removing the conditional check here since it's now handled by the parent component
  return (
    <div className="md:hidden bg-elfPink-light py-4 px-4 absolute top-16 left-0 right-0 z-50 shadow-md">
      <nav className="flex flex-col space-y-4">
        <Link 
          to="/" 
          className="rounded text-foreground hover:text-elfGreen-ink font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700"
          onClick={onClose}
        >
          Home
        </Link>
        <Link 
          to="/elf-letter-generator/" 
          className="rounded text-foreground hover:text-elfGreen-ink font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700"
          onClick={onClose}
        >
          Free Elf Letter Generator
        </Link>
        <Link 
          to="/blog/" 
          className="rounded text-foreground hover:text-elfGreen-ink font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700"
          onClick={onClose}
        >
          Blog
        </Link>
        <Link 
          to="/about/" 
          className="rounded text-foreground hover:text-elfGreen-ink font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700"
          onClick={onClose}
        >
          About Us
        </Link>
        {isAdmin ? (
          <Button
            className="bg-elfGreen-ink hover:bg-[#1b422c] text-white focus-visible:ring-slate-700 font-semibold rounded-xl text-center transition-colors duration-300 w-full"
            onClick={() => {
              onClose();
              onAdminDashboardClick();
            }}
          >
            Admin Dashboard
          </Button>
        ) : (
          <Button
            className="bg-elfRed-ink hover:bg-[#892638] text-white focus-visible:ring-slate-700 font-semibold rounded-xl text-center transition-colors duration-300 w-full"
            onClick={() => {
              onClose();
              onSignUpClick();
            }}
          >
            Sign Up
          </Button>
        )}
      </nav>
    </div>
  );
};

export default MobileMenu;
